export async function createLinkedMapPortal({
  title,
  createMindMap,
  buildCommand,
  executeCommand,
}) {
  if (typeof createMindMap !== 'function' || typeof buildCommand !== 'function' || typeof executeCommand !== 'function') {
    throw new Error('Linked-map creation requires create, build, and execute operations');
  }

  const created = await createMindMap(title);
  if (!created?.id) throw new Error('The server did not create a map');

  try {
    const command = buildCommand(created);
    const nodeId = executeCommand(command);
    if (!nodeId) throw new Error('The linked-map command was not applied');
    return { mindmapId: created.id, nodeId, command };
  } catch (error) {
    error.createdMindmapId = created.id;
    throw error;
  }
}
